/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportSsrsViewerDetails {
    getFixupPrototypeFunction() { return ReportSsrsViewerDetails.fixupPrototype; }

    static newInstance(model: Partial<ReportSsrsViewerDetails>): ReportSsrsViewerDetails {
        let obj = Object.assign(new ReportSsrsViewerDetails(), model);
        ReportSsrsViewerDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportSsrsViewerDetails>): ReportSsrsViewerDetails {
        if (!model) return null;
        return ReportSsrsViewerDetails.newInstance(<ReportSsrsViewerDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportSsrsViewerDetails) {
        if (!obj) return;

        models.ReportSsrsViewerDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportSsrsViewerDetails): boolean {
        Object.setPrototypeOf(obj, ReportSsrsViewerDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.parameters) {
            for (let val of this.parameters) {
                models.ReportSsrsParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * SSRS path of the report on the report server
     */
    report_path: string;

    /**
     * Parameters the viewer passes to the report, scoped to the current user
     */
    parameters: Array<models.ReportSsrsParameter>;

}
